import Http from "./Http";

export default {
    async getCountry() {
        return await Http.get('general/country')
    },
    async getDashboardMessage(dashboard_version) {
       return await Http.get(`/general/dashboard/message?version=${dashboard_version}`);
    },
    async getHypePopUp(data) {
        return await Http.get(`/general/app/marketingPopup?${data}`)
    },
    async getHypePopUpStatistics(id,data){
        return await Http.get(`/general/app/marketingPopup/${id}/statistics?${data}`)
    },
    async getHypePopUpById(data) {
        const popup_id = data.popup_id
        const type = data.type
        return await Http.get(`/general/app/marketingPopup?type=${type}&id=${popup_id}`)
    },

    async getAppParamsKeys() {
        return await Http.get(`/general/app/applicationParamsKeys`)
    },
    async getAppParams() {
        return await Http.get(`/general/app/applicationParams`)
    },

    async getParticipationUsers(popup_id,page=1,limit=10) {
        return await Http.get(`/general/app/marketingPopup/${popup_id}/participation?page=${page}&limit=${limit}`)
    },
    async updateAppParams(data) {
        return await Http.post(`/general/app/updateAppParams`, data, {
            headers: {
                'Content-Type':'multipart/form-data'
     }
        })
    },
    async deleteAppParamsImage(data){
        return await Http.post(`/general/app/deleteAppParamsImage` ,data);
    },
    async createHypePopUp(data) {
        return await Http.post(`/general/app/marketingPopup`, data, {
            headers: {
                'Content-Type':'multipart/form-data'
            }
        })
    },
    async updateHypePopUp(id, data) {
        return await Http.post(`/general/app/marketingPopup/${id}`, data, {
            headers: {
                'Content-Type':'multipart/form-data'
            }
        })
    },
    async addHypePopUpImage(data) {
        return await Http.post(`/general/app/marketingPopup/image`, data, {
            headers: {
                'Content-Type':'multipart/form-data'
            }
        })
    },
    async deleteHypePopUp(id) {
        return await Http.delete(`/general/app/marketingPopup/${id}`)
    },
    async deleteHypePopUpImage(id) {
        return await Http.delete(`/general/app/marketingPopup/image/${id}`)
    },
    async getHypePopUpShowSectionData(){
        return await Http.get(`/general/deeplink_campaign_methods`)
    },
    async getactionTextOptions() {
        return await Http.get(`/general/app/marketingPopup/actionText`)
    },
    async getCrmOptIns(data=''){
        return await Http.get(`/general/optins?${data}`);
    },
    async getSingleCrmOptIns(data='',id){
        return await Http.get(`/general/optins?${data}&id=${id}`);
    },
    async createCrmOptIn(data){
        return await Http.post(`/general/createCrmOptIn`,data , {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    async addCrmOptInTranslation(data,id){
        return await Http.post(`/general/editCrmOptIn/${id}`,data)
    },
    async deleteCrmOptInTranslation(data,id){
        return await Http.post(`/general/editCrmOptIn/${id}`,data)
    },
    async deleteCrmOptIn(id){
        return await Http.post(`/general/deleteCrmOptIn/${id}`);
    },
    async editCrmOptIn(id,data){

        return await Http.post(`/general/editCrmOptIn/${id}`, data, {
            headers: {
                'Content-Type':'multipart/form-data'
            }
        })
    },
    async getReportCrmOptIns(data){

        return await Http.get(`/general/getReportCrmOptIns?${data}`)
    },

    async getDirContent(data){
        return await Http.get(`/general/dir?${data}`)
    },

    async getFile(data){
        return await Http.get(`/general/dir/file?${data}`)
    },

    async createDirectory(data){
        return await Http.post(`/general/dir`, data)
    },

    async uploadFile(data){
        return await Http.post(`/general/dir/upload`, data)
    },

    async deleteFile(data){
        return await Http.delete(`/general/dir/file?${data}`)
    },

    async deleteDirectory(data){
        return await Http.delete(`/general/dir?${data}`)
    },

    async getDashboardDefinitions(data){
        return await Http.get(`/general/dashboard/definitions?${data}`)
    },
    async getDashboardVersion(version){
        return await Http.get(`/general/dashboard/version?version=${version}`)
    },
    async getDashboardGitChangelog(){
        return await Http.get(`/general/dashboard/git_changelog`)
    },
    async getApiChangelog(){
        return await Http.get(`/general/dashboard/api_changelog`)
    },
    async createDashboardChangelog(data){
        return await Http.post(`/general/dashboard/changelog`, data)
    },
    async updateDashboardChangelog(data){
        return await Http.post(`/general/dashboard/changelog/update`, data)
    },
    async deleteDashboardChangelog(id){
        return await Http.delete(`/general/dashboard/changelog?id=${id}`)
    },
    async getTermsAndConditions(){
        return await Http.get(`/general/getTermsAndConditions`)
    },
    async editTermsAndConditions(data) {
        return await Http.post(`/general/editTermsAndConditions`, data, {
            headers: {
                'Content-Type':'multipart/form-data'
            }
        })
    },
    async createTermsAndConditions(data) {
        return await Http.post(`/general/createTermsAndConditions`, data, {
            headers: {
                'Content-Type':'multipart/form-data'
            }
        })
    },
    async getAppCrmMimic(){
        return await Http.get(`/general/getAppCrmMimic`) ;
    },
    async createAppCrmMimic(data) {
        return await Http.post(`/general/createAppCrmMimic`, data, {
            headers: {
                'Content-Type':'multipart/form-data'
            }
        })
    },
    async deleteAppCrmMimic(id){
        return await Http.delete(`/general/deleteAppCrmMimic/${id}`)
    } ,
    async getDashboardHelp(data){
        return await Http.get(`/general/getDashboardHelp?${data}`)
    },
    async getSecurityGroupRules(data) {
        return await Http.get(`/general/security_groups/tenantrules`, { params: data })
    },
    async addTenantSecurityGroupRule(data) {
        return await Http.post(`/general/security_groups/addtenantrule`, data)
    },
    async removeTenantSecurityGroupRule(data) {
        return await Http.delete(`/general/security_groups/removetenantrule`, { params: data })
    },
    async getTenantVPNUsers(data) {
        return await Http.get(`/general/vpn/tenantusers?${data}`)
    },
    async addTenantVPNUsers(data) {
        return await Http.post(`/general/vpn/tenantusers`, data)
    },
    async removeTenantVPNUser(username) {
        return await Http.delete(`/general/vpn/tenantusers/${username}`)
    },
    async autocomplete(data){
        return await Http.get(`/general/autocomplete` ,{ params: data });
    },
    async getDeeplinkCampaign(data){
        return await Http.get(`/general/deeplink_campaign`)
    },
    async getDeeplinkCampaignMethods(data){
        return await Http.get(`/general/deeplink_campaign_methods`)
    },
    async createDeeplinkCampaign(data) {
        return await Http.post(`/general/deeplink_campaign`, data, {
            headers: {
                'Content-Type':'multipart/form-data'
            }
        })
    },
    async deleteDeeplinkCampaign(guid) {
        return await Http.delete(`/general/deeplink_campaign/${guid}`)
    },

    async getDeeplinkSecondLevelOptions(second_level){
        return await Http.get(`/general/deeplink_second_level_options/${second_level}`)
    },
    async getApplicationMedia(){
        return await Http.get(`/general/media`);
    },
    async addApplicationMedia(data){
        return await Http.post(`/general/media`, data, {
            headers: {
                'Content-Type':'multipart/form-data'
            }
        })
    },
    async updateApplicationMedia(id,data) {
        return await Http.post(`/general/media/${id}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    async getApplicationMediaAvailablePositions() {
        return await Http.get(`/general/media/availablePositions`);
    },
    async deleteApplicationMedia(id){
        return await Http.delete(`/general/media/${id}`);
    },
    async duplicateHypePopUp(data){
        return await Http.post(`/general/app/marketingPopup/duplicate`, data);
    }
    ,

    // Reactions
    async saveReaction(data) {
        return await Http.post(`/general/reaction`, data)
    },
    async getReaction(contentId, params = {}) {
        return await Http.get(`/general/reaction/${contentId}`, { params })
    },
    async getReactionAll(contentId, params = {}) {
        return await Http.get(`/general/reaction/all/${contentId}`, { params })
    }

}
